import API from "../../../utils/api";

export const getManualsApi = async (filters) => {
  const response = await API.get("settings/manual", { params: filters });
  return { response };
};

export const addManualsApi = async (data) => {
  const response = await API.post("settings/manual", data);
  return { response };
};

export const updateManualsApi = async (data, id) => {
  const response = await API.put(`settings/manual/${id}`, data);
  return { response };
};

export const deleteManualsApi = async (id) => {
  const response = await API.delete(`settings/manual/${id}`);
  return { response };
};
